import Catalog from "./catalog";

export default Catalog;
